import { BucketType, TimeRange } from '@/schema'

import { buildCommentRoute, CommentNavigationState } from '../../utils/routes'
import { COMMENT_FILTERS_STORAGE_KEY } from '../comment'
import { ECommentStatus } from '../view-tfl-uploaded/constants'

export const WEEK_TIME_RANGES: TimeRange[] = [
  TimeRange.this_month,
  TimeRange.last_month,
  TimeRange.last_quarter,
]

export const MONTH_TIME_RANGES: TimeRange[] = [
  TimeRange.this_quarter,
  TimeRange.last_quarter,
  TimeRange.last_6_months,
  TimeRange.year_to_date,
]

/**
 * Get the time range options for the given period
 */
export const getTimeRangeOptions = (period: BucketType): TimeRange[] =>
  period === BucketType.week ? WEEK_TIME_RANGES : MONTH_TIME_RANGES

/**
 * Coerce the time range for the given period
 */
export const coerceTimeRangeForPeriod = (
  period: BucketType,
  timeRange: TimeRange
): TimeRange => {
  const allowedRanges = getTimeRangeOptions(period)
  const fallback =
    period === BucketType.week ? TimeRange.this_month : TimeRange.this_quarter
  return allowedRanges.includes(timeRange) ? timeRange : fallback
}

/**
 * Open the comment path with the given filters
 * @param filters - The filters to open the comment path with
 */
export const openCommentPath = (filters: CommentNavigationState['filters']) => {
  const route = buildCommentRoute({
    ...filters,
    status: ECommentStatus.OPEN,
  })
  if (route.state?.filters) {
    localStorage.setItem(
      COMMENT_FILTERS_STORAGE_KEY,
      JSON.stringify(route.state.filters)
    )
  }
  window.open(route.path, '_blank')
}
